<template>
	<div class="LoginPage">
		<div class="LoginPage-wrapper">
			<div class="LoginPage-top">
				<img class="LoginPage-logo" alt="logo" :src="'img/hp-favicon.svg'" /> Autoflow
			</div>
			<div class="LoginPage-form">
				<div class="LoginPage-hpid">
					<p class="text-center">
						{{ $t('Sign in with your') }} <b>{{ $t('HP account') }}</b>
					</p>
					<button
						type="button"
						class="button button--info button--big button--block LoginPage-hpid-btn"
						@click="loginWithHPID"
					>
						{{ $t('Sign in') }}
					</button>
					<h6 class="title text-center" style="margin-top: 10px">
						{{ $t('If you have any logging issues, please contact ') }}
						<a style="color: #23b7e5" href="mailto:siteflowsupport@hp.com">siteflowsupport@hp.com</a>
					</h6>
				</div>
				<div v-if="errorMessage" class="form-group u-colorDanger">{{ errorMessage }}</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import _get from 'lodash/get';

export default {
	data() {
		return {
			errorMessage: null
		};
	},
	computed: {
		isAuthenticated() {
			return _get(this, '$store.getters["auth/isAuthenticated"]');
		}
	},
	created() {
		if (this.isAuthenticated) this.redirect();
	},
	methods: {
		loginWithHPID() {
			const hpIdAuthorize = _get(window, '$config.ssoAuthorize');
			if (!hpIdAuthorize) {
				this.errorMessage = this.$t('HPID login is not available');
				return;
			}

			const locale = _get(this, '$i18n.locale');
			const localeQuery = locale ? `&locale=${locale}` : '';
			window.location.href = `${hpIdAuthorize}${localeQuery}`;
		},
		redirect() {
			const redirectTo = _get(this, '$route.query.redirectTo');
			const path = redirectTo || '/';
			this.$router.push({ path });
		}
	}
};
</script>
<style lang="scss">
.LoginPage {
	width: 100vw;
	min-height: 100vh;
	display: flex;
	justify-content: center;
	.LoginPage-wrapper {
		margin: 20px;
		max-width: 400px;
		flex-grow: 1;
	}
	.LoginPage-top {
		color: #3a3f51;
		padding: 10px 20px;
		margin-bottom: 20px;
		text-align: center;
		font-size: 40px;
		font-weight: 400;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.LoginPage-top img {
		max-height: 40px;
		padding-right: 10px;
	}
	.LoginPage-form {
		background-color: white;
		word-wrap: break-word;
		background-clip: border-box;
		border: 1px solid rgba(0,0,0,.125);
		padding: 20px;
		.LoginPage-hpid {
			margin-bottom: 20px;
		}
		.LoginPage-hpid-btn {
			background-color: rgb(0, 136, 211);
			border-color: rgb(0, 136, 211);
		}
		.LoginPage-form-actions {
			margin-top: 20px;
		}
	}
}
</style>
